import { render, staticRenderFns } from "./Collector.vue?vue&type=template&id=7ceaeb18&scoped=true&"
import script from "./Collector.vue?vue&type=script&lang=js&"
export * from "./Collector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceaeb18",
  null
  
)

export default component.exports